import { t } from "i18next";
import { z } from "zod";

export const EditTitleVisitSchema = z.object({
  title: z.string().min(1, t("schemas.editTitleVisit.title.min")),
});

export type EditTitleVisitSchemaType = z.infer<typeof EditTitleVisitSchema>;
